import {
  getDefaultSoftwareProduct,
  getDefaultSupportAddon
} from "./methods";
import {getObjectFromSession} from "../../sharedGlobal";
import {moduleNamespace} from "./constants";

/**
 * The default state of the product manager on page load.
 */
const defaultState = () => ({
  enableSupportAddon: getObjectFromSession(moduleNamespace, 'enableSupportAddon') ?? false,
  supportedCurrencies: getObjectFromSession(moduleNamespace, 'supportedCurrencies') ?? {
    GBP: {
      enabled: false,
      symbol: '£',
    },
    USD: {
      enabled: false,
      symbol: '$',
    },
  },

  softwareProduct: getObjectFromSession(moduleNamespace,'softwareProduct') ?? getDefaultSoftwareProduct(),
  supportAddon: getObjectFromSession(moduleNamespace,'supportAddon') ?? getDefaultSupportAddon(),

  errors: {},
  loading: false,
});

import getters from './getters';
import actions from './actions';
import mutations from './mutations';
export default {
  namespaced: true,
  state: defaultState(),
  getters,
  actions,
  mutations,
};
